import builder from '../builder';
import HotelDoubleBed1 from '../../streamline-icons/bold/hotel-double-bed-1.svg';

export default builder('IconHotelDoubleBed1Bold', HotelDoubleBed1);
